import { ec as EC } from 'elliptic';
import { sha256 } from 'js-sha256';
import { wordlist } from '../wordlist';
import * as state from './state';
import { client, subscribeToPersonalTopic } from './mqtt';

export const ec = new EC('secp256k1');

export function generateFingerprint(publicKey: string): string {
    const hash = sha256.array(publicKey);
    const words: string[] = [];

    for (let i = 0; i < 8; i++) {
        const byte = hash[i];
        words.push(wordlist[(byte >> 4) & 0xF]);
        words.push(wordlist[byte & 0xF]);
    }
    return words.join(' ');
}

export function generateKeyPair() {
    const keyPair = ec.genKeyPair();
    state.setUserKeyPair(keyPair);
    state.setUserPublicKey(keyPair.getPublic('hex'));
    state.setUserFingerprint(generateFingerprint(keyPair.getPublic('hex')));
    
    if (client && client.connected) {
        subscribeToPersonalTopic();
    }
}
